import AccordionBlock from "@components/AccordionBlock";
import { BannerBlock } from "@components/BannerBlock";
import InsurancePickerBlock from "@components/ChatBoxComponents/InsurancePickerBlock";
import { ColorPaletteBlock } from "@components/ColorPaletteBlock";
import { ContactBlock } from "@components/ContactBlock";
import { ContactUsBlock } from "@components/ContactUsBlock";
import FAQBlock from "@components/FAQBlock";
import FAQListBlock from "@components/FAQListBlock";
import FileBlock from "@components/FileBlock";
import FileListBlock from "@components/FileListBlock";
import FormBlock from "@components/FormBlock";
import ImageBlock from "@components/ImageBlock";
import InformationBlock from "@components/InformationBlock";
import LinkBlock from "@components/LinkBlock";
import { LinkTeaserBlock } from "@components/LinkTeaserBlock";
import ListBlock from "@components/ListBlock";
import OrderBlock from "@components/OrderBlock";
import Page from "@components/Page";
import PaymentDaysBlock from "@components/PaymentDaysBlock";
import QuizBlock from "@components/QuizBlock";
import QuoteBlock from "@components/QuoteBlock";
import RestrictedRichTextBlock from "@components/RestrictedRichTextBlock";
import RichTextBlock from "@components/RichTextBlock";
import SectionBlock from "@components/SectionBlock";
import ShortCutsBlock from "@components/ShortCutsBlock";
import TableBlock from "@components/TableBlock";
import TeaserBlock from "@components/TeaserBlock";
import TeaserList from "@components/TeaserList";
import { TextList } from "@components/TextList";
import TimelineBlock from "@components/TimelineBlock";
import VideoBlock from "@components/VideoBlock";
import React from "react";

import { ContentAreaItem } from "types/ContentAreaItem";
import { Context } from "types/context/Context";

import PersonalizationBlock from "../PersonalizationBlock";

type BlockFactory = (
  blockData: unknown,
  uniqueKey: string,
  context: Context,
  maxWidth: number,
) => React.ReactNode;

const blockRegistry: Record<string, BlockFactory> = {
  insurancepickerblock: (blockData, uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <InsurancePickerBlock blockData={blockData as any} uniqueKey={uniqueKey} context={context} />
  ),
  faq: (blockData, uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <FAQBlock blockData={blockData as any} uniqueKey={uniqueKey} context={context} />
  ),
  accordionblock: (blockData, uniqueKey, context, maxWidth) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <AccordionBlock
      blockData={blockData as any}
      context={context}
      uniqueKey={uniqueKey}
      maxWidth={maxWidth}
    />
  ),
  personalizationblock: (blockData, uniqueKey, context, maxWidth) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <PersonalizationBlock
      blockData={blockData as any}
      context={context}
      uniqueKey={uniqueKey}
      maxWidth={maxWidth}
    />
  ),
  sectionblock: (blockData, uniqueKey, context, maxWidth) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SectionBlock
      blockData={blockData as any}
      context={context}
      uniqueKey={uniqueKey}
      maxWidth={maxWidth}
    />
  ),
  page: (blockData, uniqueKey, context, maxWidth) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <Page
      blockData={blockData as any}
      context={context}
      uniqueKey={uniqueKey}
      maxWidth={maxWidth}
    />
  ),
  teaserblock: (blockData, uniqueKey, context, maxWidth) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <TeaserBlock
      blockData={blockData as any}
      context={context}
      uniqueKey={uniqueKey}
      maxWidth={maxWidth}
    />
  ),
  videoblock: (blockData, uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <VideoBlock blockData={blockData as any} uniqueKey={uniqueKey} context={context} />
  ),
  fileblock: (blockData, uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <FileBlock blockData={blockData as any} uniqueKey={uniqueKey} context={context} />
  ),
  tableblock: (blockData, uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <TableBlock blockData={blockData as any} uniqueKey={uniqueKey} context={context} />
  ),
  richtextblock: (blockData, uniqueKey) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <RichTextBlock blockData={blockData as any} uniqueKey={uniqueKey} />
  ),
  informationblock: (blockData, uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <InformationBlock blockData={blockData as any} uniqueKey={uniqueKey} context={context} />
  ),
  timelineblock: (blockData, uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <TimelineBlock blockData={blockData as any} uniqueKey={uniqueKey} context={context} />
  ),
  contactblock: (blockData, uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <ContactBlock blockData={blockData as any} uniqueKey={uniqueKey} context={context} />
  ),
  quizblock: (blockData, _uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <QuizBlock blockData={blockData as any} context={context} />
  ),
  quoteblock: (blockData, uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <QuoteBlock blockData={blockData as any} uniqueKey={uniqueKey} context={context} />
  ),
  link: (blockData, uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <LinkBlock blockData={blockData as any} uniqueKey={uniqueKey} context={context} />
  ),
  restrictedrichtextblock: (blockData, uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <RestrictedRichTextBlock blockData={blockData as any} uniqueKey={uniqueKey} context={context} />
  ),
  shortcutsblock: (blockData, _uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <ShortCutsBlock blockData={blockData as any} context={context} />
  ),
  listblock: (blockData, uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <ListBlock blockData={blockData as any} uniqueKey={uniqueKey} context={context} />
  ),
  faqlistblock: (blockData, uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <FAQListBlock blockData={blockData as any} uniqueKey={uniqueKey} context={context} />
  ),
  formblock: (blockData, uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <FormBlock blockData={blockData as any} uniqueKey={uniqueKey} context={context} />
  ),
  imageblock: (blockData, uniqueKey, context, maxWidth) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <ImageBlock
      blockData={blockData as any}
      uniqueKey={uniqueKey}
      context={context}
      maxWidth={maxWidth}
    />
  ),
  orderblock: (blockData, uniqueKey) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <OrderBlock blockData={blockData as any} uniqueKey={uniqueKey} />
  ),
  filelistblock: (blockData, uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <FileListBlock blockData={blockData as any} uniqueKey={uniqueKey} context={context} />
  ),
  colorpaletteblock: (blockData, uniqueKey) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <ColorPaletteBlock blockData={blockData as any} uniqueKey={uniqueKey} />
  ),
  teaserlistblock: (blockData, _uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <TeaserList blockData={blockData as any} context={context} />
  ),
  paymentdaysblock: (blockData, uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <PaymentDaysBlock blockData={blockData as any} uniqueKey={uniqueKey} context={context} />
  ),
  bannerblock: (blockData, uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <BannerBlock blockData={blockData as any} uniqueKey={uniqueKey} context={context} />
  ),
  contactusblock: (blockData, _uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <ContactUsBlock blockData={blockData as any} context={context} />
  ),
  linkteaserblock: (blockData, _uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <LinkTeaserBlock blockData={blockData as any} context={context} />
  ),
  textlist: (blockData, _uniqueKey, context) => (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <TextList blockData={blockData as any} context={context} />
  ),
};

interface IRender {
  contentAreaItem: ContentAreaItem;
  uniqueKey: string;
  context: Context;
  maxWidth: number;
}

const Render = ({ contentAreaItem, uniqueKey, context, maxWidth }: IRender): React.ReactNode => {
  const typeName = Object.keys(contentAreaItem)[0];
  const render = blockRegistry[typeName?.toLowerCase()];
  if (!render) return null;
  return render(contentAreaItem[typeName], uniqueKey, context, maxWidth);
};

export default Render;
